const filterScrollDownInit = () => {
  const url = window.location.href;
  const filter = document.querySelector('.insight-archive__filter');

  if (url.includes('auteur') || url.includes('sector')) {
    filter.scrollIntoView();
  }
};

export default filterScrollDownInit;
